<template>
  <div class="main">
    <div class="c-nav-tabs">
      <ul class="nav-tabs">
        <li :class="{ active: !status }">
          <router-link :to="`/pc/meeting/${type}`">我的全部会议</router-link>
        </li>
        <li :class="{ active: status == 1 }">
          <router-link :to="`/pc/meeting/${type}/1`">未开始</router-link>
        </li>
        <li :class="{ active: status == 2 }">
          <router-link :to="`/pc/meeting/${type}/2`">进行中</router-link>
        </li>
        <li :class="{ active: status == 3 }">
          <router-link :to="`/pc/meeting/${type}/3`">已结束</router-link>
        </li>
      </ul>
    </div>
    <div class="m-main-wrap navs-tab">
      <div class="m-area u-mb20">
        <div class="c-search">
          <input
            type="text"
            class="c-input"
            v-model="keyword"
            placeholder="请输入会议名称"
          />
          <span class="icon icontemp search" @click="search()"></span>
        </div>
      </div>
      <div class="c-meeting-list" v-for="o in list" :key="o.id">
        <div class="logo">
          <img :src="o.logoUrl || './images/logo.jpg'" alt="" />
        </div>
        <div class="mian">
          <div class="name">
            <a :href="o.nameHref" target="_blank">{{ o.name }}</a>
          </div>
          <div class="tag-wrap">
            <div
              class="c-tag"
              :class="{
                proposed:
                  !o.status ||
                  o.status == 'proposed' ||
                  o.status == 'readytolaunch',
                launched: o.status == 'launched',
                completed: o.status == 'completed'
              }"
            >
              {{ statusJosn[o.status] || "未开始" }}
            </div>
            <div class="metting-type u-mb0" v-if="type == 'webinar'">
              {{ o.videoType == 1 ? "直播活动" : "点播活动" }}
            </div>
          </div>
          <div class="area-wrap u-mt10">
            <div class="area-list u-mr25" v-if="o.startTime && o.endTime">
              <span class="icon icontemp time"></span>
              <span class="text">{{
                (o.startTime || "--") +
                  (o.startTime ? "至" : "") +
                  (o.endTime || "")
              }}</span>
            </div>
            <div class="area-list" v-if="o.address">
              <span class="icon icontemp area"></span>
              <span class="text">{{ o.address || "--" }}</span>
            </div>
          </div>
        </div>
        <div class="goto">
          <div class="m-bind notbutton">
            <a
              class="text"
              :href="type == 'seminar' ? o.ticketUrlShort : o.nameHref"
              target="_blank"
            >
              {{ type == "seminar" ? "查看门票" : "进入会场" }}
            </a>
          </div>
        </div>
      </div>

      <div class="m-pagination u-mt30" v-if="list.length > 0">
        <a-pagination
          @change="onChange"
          :defaultPageSize="pageSizeOptions"
          :total="total"
          :current="current"
        ></a-pagination>
      </div>

      <div class="m-area u-mt40" v-if="!isLoading && list.length === 0">
        <a-empty description="暂无数据"></a-empty>
      </div>
<!--      <div class="m-loading-data" v-if="isLoading"></div>-->
    </div>
  </div>
</template>

<script>
import member from "../../services/member";
import { tenantId, sess, fileUrl } from "../../common/sbase";
import { cr } from "fire-wind-water/core";
import moment from "moment";

export default {
  name: "Meeting",
  data() {
    return {
      keyword: "",
      type: "",
      status: "",
      current: 1,
      total: 0,
      pageSizeOptions: 20,
      isLoading: true,
      list: [],
      webinar: {
        1: 1,
        2: 3,
        3: 4
      },
      seminar: {
        1: ["proposed", "readytolaunch"],
        2: ["launched"],
        3: ["completed"]
      },
      statusJosn: {
        proposed: "未开始",
        readytolaunch: "未开始",
        launched: "进行中",
        completed: "已结束"
      }
    };
  },
  methods: {
    isLink() {
      if (this.type != this.$route.params.type) {
        this.keyword = "";
        this.total = 0;
        this.list = [];
      }
      this.type = this.$route.params.type;
      this.status = this.$route.params.status;
      this.current = 1;
      this.getList();
    },
    getWebinarList() {
      const info = {
        tenantId: tenantId,
        videoType: -1,
        keyword: this.keyword,
        sess: sess,
        webStatus: this.webinar[this.status] || -1,
        orderBy: "startTime",
        sort: "desc",
        start: (this.current - 1) * this.pageSizeOptions,
        num: this.pageSizeOptions
      };
      member.webinarList(info).subscribe(data => {
        if (data.result == 0) {
          this.total = data.content.total;
          this.list = data.content.items;
          this.initList();
        } else {
          this.$message.error(data.desc);
        }
      });
    },
    getSeminarList() {
      const info = {
        tenantId: tenantId,
        sess: sess,
        keyword: this.keyword,
        status: this.seminar[this.status] || -1,
        needTopic: 1,
        sortName: "startTime",
        sortOrder: "desc",
        start: (this.current - 1) * this.pageSizeOptions,
        num: this.pageSizeOptions
      };
      member.seminarList(info).subscribe(data => {
        if (data.result == 0) {
          this.total = data.content.total || 0;
          this.list = data.content.items || [];
          this.initList();
        } else {
          this.$message.error(data.desc);
        }
      });
    },
    initList() {
      this.isLoading = false;
      window.$sk.loading.hide();
      cr.each(this.list, d => {
        if (!d.name) {
          d.name = d.title;
        }
        if (d.startTime < 0) {
          d.startTime = null;
        }
        if (d.endTime < 0) {
          d.endTime = null;
        }
        d.startTime = d.startTime
          ? moment(d.startTime * 1000).format("YYYY-MM-DD HH:mm")
          : "";
        d.endTime = d.endTime
          ? moment(d.endTime * 1000).format("YYYY-MM-DD HH:mm")
          : "";
        if (this.type == "seminar") {
          d.nameHref = d.topic;
          d.logoUrl = d.logoMapId
            ? `${fileUrl}?mappingId=${d.logoMapId}`
            : null;
        } else {
          d.nameHref = d.enterShortUrl;
          d.logoUrl = d.coverUrl;
          if (d.webStatus == 1) {
            d.status = "proposed";
          }
          if (d.webStatus == 3) {
            d.status = "launched";
          }
          if (d.webStatus == 4) {
            d.status = "completed";
          }
        }
      });
    },
    search() {
      this.current = 1;
      this.getList();
    },
    onChange(current) {
      this.current = current;
      this.getList();
    },
    getList() {
      this.isLoading = true;
      if (this.type == "webinar") {
        this.getWebinarList();
      } else {
        this.getSeminarList();
      }
    }
  },
  created() {
    this.isLink();
  },
  watch: {
    $route: {
      handler: function() {
        this.isLink();
      },
      // 深度观察监听
      deep: true
    }
  }
};
</script>

<style scoped></style>
